import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

const ModuleDetailsPlaceholder = () => {
  return (
    <>
      <div
        role="alert"
        aria-busy="true"
        className="px-4 min-h-[160px] bg-expressive-dark-blue"
      >
        <div className="mb-1">
          <Shimmer width={280} height={12} className="mb-2" />
        </div>
        <div className="mb-2">
          <Shimmer width={280} height={12} className="mb-3" />
        </div>
        <div className="flex items-center mb-8">
          <Shimmer width={24} height={24} rounded />
          <div className="ml-2">
            <Shimmer width={280} height={8} />
          </div>
        </div>
        <div>
          <Shimmer width={280} height={12} noOfLines={2} className="mb-2" />
        </div>
      </div>
      <div className="px-4 py-10">
        {[0, 1, 2].map((_, idx) => (
          <div
            key={idx}
            className="flex relative p-4 w-full mx-auto mb-3 bg-white rounded border border-subdued"
          >
            <Shimmer width={64} height={64} rounded />
            <div className="ml-3">
              <Shimmer width={100} height={12} className="mb-4" />
              <Shimmer width={200} height={12} noOfLines={2} className="mb-1" />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default ModuleDetailsPlaceholder
